import React, { useEffect, useState } from "react";
import Fade from 'react-reveal/Fade';
import "../../stylesheet/WhtLbl.css";
import { Link, useLocation } from "react-router-dom";

const WhtLbl = () => {

  const { pathname } = useLocation(); 
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
 

  useEffect(() => {

    // Add a scroll event listener to check when the component is in the viewport
    const handleScroll = () => {
      const element = document.getElementById('scroll-fade');
      const element2 = document.getElementById('scroll-fade2');
      const element3 = document.getElementById('scroll-fade3');
if( window.innerWidth > 1340) {

  
  if (element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top <= window.innerHeight;
    setIsVisible(isVisible);
    console.log(rect  )
  }
  if (element2) {
    const rect = element2.getBoundingClientRect();
    const isVisible2 = rect.y > -800;
    setIsVisible2(isVisible2);
  }
  if (element3) {
    const rect = element3.getBoundingClientRect();
    const isVisible3 = rect.y;
    setIsVisible3(isVisible3);
  } 

} else {
  if (element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible(isVisible);
  }
  if (element2) {
    const rect = element.getBoundingClientRect();
    const isVisible2 = window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible2(isVisible2);
  }
  if (element3) {
    const rect = element3.getBoundingClientRect();
    const isVisible3 =  window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible3(isVisible3);
  }
}
};

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  useEffect(() => {
    window.scrollTo(10, 0);
  }, [pathname]);



  return (
    <div id="wlb-cont">
       <div id="scroll-fade">
        <Fade bottom when={isVisible}>
      <div id="wl-sec-1">
        <div className="ws-l">
          <div className="ws-title">What is white labeling</div>
          <p>
            What's special about your product, service, or company? Use this
            space to highlight the things that set you apart from your
            competition, whether it's a special feature, a unique philosophy, or
            awards and recognition that you have received. Think of this as your
            elevator pitch to get the reader's attention.
          </p>
          <div className="btn btn-b">Explore</div>
        </div>
        <div className="ws-r">
          <img src="./imgs/wlb.jpg" alt="" />
        </div>
      </div>
      </Fade>
      </div>

      <div id="scroll-fade2">
      <Fade bottom when={isVisible2}>
      <div id="wl-sec-2">
        <h1>How we create your brand</h1>
        <div className="hwcb-grid">
          <div className="hwcb">
            <img src="./imgs/whc-1.jpg" alt="" />
            <p>
              MAIL US YOUR NEED AND WE'LL RRVERT YOU BACK WITH THE BEST SOLUTION
            </p>
          </div>
          <div className="hwcb">
            <img src="./imgs/whc-2.jpg" alt="" />
            <p>
              OUR EXPERT TEAM WILL HELP YOU IN CREATING YOUR PERSONALIZE BRAND
            </p>
          </div>
          <div className="hwcb">
            <img src="./imgs/whc-3.jpg" alt="" />
            <p>YOUR BRAND IS MARKET READY TO GRAB CUSTOMER'S ATTENTION </p>
          </div>
        </div>
      </div>
  </Fade>
  </div>
      
    <div id="scroll-fade3">
      <Fade bottom when={isVisible3}>
      <div id="wl-sec-3">
        <div className="ws-l">
          <div className="ws-title">build your dream brand now !!!</div>

          <Link to={"/signIn"} className="btn btn-b">Contact us</Link>
        </div>
        <div className="ws-r">
          <img src="./imgs/wh-sec-3.jpg" alt="" />
        </div>
      </div>
      </Fade>
      </div>
    </div>
  );
};

export default WhtLbl;
